import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/** Pass URL and convert them to lower case. */
@Injectable()
export class CustomUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const routeRegex = /^([/][A-Za-z]+)([/][A-Za-z]+)?/;
    const routeMatch = routeRegex.exec(url);
    if (routeMatch != null) {
      url = url.replace(routeMatch[0], routeMatch[0].toLowerCase());
    }
    return super.parse(url);
  }
}
